import React from 'react';
import { Col, Row } from 'reactstrap';
import { CrudForm, HelperFunctions, TimeSlots } from '@westernmilling/react_component_library';

import Summary from 'components/Forms/DispatchOrder/Summary';

export default class OrderUnauthorizedViewForm extends CrudForm {
  formType = () => 'Order';

  ship1 = () => (
    <Col lg={4} md={12}>
      {this.getRow('source_location__name', 'Pickup Location')}
    </Col>
  );

  ship2 = () => (
    HelperFunctions.isEmpty(this.getItem().appointment) ? this.requestedDate() : this.appointmentDate()
  );

  requestedDate = () => {
    const timeSlot = TimeSlots.GetTimeSlotName(this.getItem().time_slot, this.getItem().requested_time_slot_time);
    return this.getRowWithValue('Requested Date', `${this.getItem().pickup_date} ${timeSlot}`);
  };

  appointmentDate = () => this.getRow('appointment', 'Appointment');

  divider = () => (
    <>
      <br />
      <hr />
      <br />
    </>
  );

  modalBodyRows = () => (
    <div>
      <Summary item={this.getItem()} />
      {this.divider()}
      <h4>
        Shipping Details
      </h4>
      <br />
      <Row>
        {this.ship1()}
        <Col lg={4} md={12}>
          {this.ship2()}
        </Col>
      </Row>
      <br />
    </div>
  );
}
